var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg083Statistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20C22 19.4477 21.5523 19 21 19H5V3C5 2.44772 4.55228 2 4 2C3.44772 2 3 2.44772 3 3V20C3 20.5523 3.44772 21 4 21H21C21.5523 21 22 20.5523 22 20ZM7 11V16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11ZM12 17C11.4477 17 11 16.5523 11 16V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V16C13 16.5523 12.5523 17 12 17ZM15 8V16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16V8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8ZM19 16V3C19 2.44772 19.4477 2 20 2C20.5523 2 21 2.44772 21 3V16C21 16.5523 20.5523 17 20 17C19.4477 17 19 16.5523 19 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg083Statistic);
export default __webpack_public_path__ + "static/media/083-statistic.c47e58a261f00e33cb1e1f64b7c6a20d.svg";
export { ForwardRef as ReactComponent };